import { get, post, put, del } from '@api/request';

export const fetchCommentsForCase = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertCommentToCase = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/notes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateComment = async (
  { litigationService },
  authenticationToken,
  { payload, noteID },
) => {
  const url = `${litigationService}/litigation/casenotes/${noteID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteComment = async (
  { litigationService },
  authenticationToken,
  { noteID },
) => {
  const url = `${litigationService}/litigation/casenotes/${noteID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};
